<template>
  <div class="AppBox">
    <div id="headNavBox">
      <img class="headLogo" :src="headImg.headLogoImg">
      <img class="headNav" :src="headImg.headNavImg" @click.stop="changeHeadNavList">
    </div>
    <div id="navLinkBox" ref="navLinkBox" class="bb">
      <router-link v-if="isEN == 1" :to="{name:'EnHome'}" class="headNavList" @click.native="changeHeadNavList">Home</router-link>
      <router-link v-if="isEN == 0" :to="{name:'Home'}" class="headNavList" @click.native="changeHeadNavList">首页</router-link>

      <router-link v-if="isEN == 1" :to="{name:'EncompanyIntroduce'}" class="headNavList" @click.native="changeHeadNavList">About us</router-link>
      <router-link v-if="isEN == 0" :to="{name:'companyIntroduce'}" class="headNavList" @click.native="changeHeadNavList">关于我们</router-link>

      <router-link v-if="isEN == 1" :to="{name:'EnBusiness'}" class="headNavList" @click.native="changeHeadNavList">Brands</router-link>
      <router-link v-if="isEN == 0" :to="{name:'Business'}" class="headNavList" @click.native="changeHeadNavList">品牌战略</router-link>

      <router-link v-if="isEN == 0" :to="{name:'SocialResponsibility'}" class="headNavList" @click.native="changeHeadNavList">社会责任</router-link>

      <router-link v-if="isEN == 0" :to="{name:'NewListCon',query:{id:5001}}"  class="headNavList" @click.native="changeHeadNavList">新闻中心</router-link>

      <router-link v-if="isEN == 1" :to="{name:'EnOverview',query:{cat:8000093}}"  class="headNavList" @click.native="changeHeadNavList">Investors</router-link>
      <router-link v-if="isEN == 0" :to="{name:'Overview',query:{cat:8000093}}"  class="headNavList" @click.native="changeHeadNavList">投资者联系</router-link>

      <router-link v-if="isEN == 0" :to="{name:'EnHome'}"  class="headNavList" @click.native="changeHeadNavList2">EN</router-link>
      <router-link v-if="isEN == 1" :to="{name:'Home'}"  class="headNavList" @click.native="changeHeadNavList2">中文</router-link>
    </div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
      isEN: 0,
      headImg: {
        headLogoImg:'static/img/headLogoImg.png',
        headNavImg:'static/img/headNavImg.png'
      }
    }
  },
  computed:{

  },
  methods:{
    changeHeadNavList:function(){
      if(this.$refs.navLinkBox.classList.contains('active')){
        this.$refs.navLinkBox.classList.remove('active');
        this.$refs.navLinkBox.style.transition = "0.5s";
      }else{
        this.$refs.navLinkBox.classList.add('active');
      }
    },
    changeHeadNavList2:function(){
      this.isEN = this.isEN === 1? 0 : 1;
      if(this.$refs.navLinkBox.classList.contains('active')){
        this.$refs.navLinkBox.classList.remove('active');
        this.$refs.navLinkBox.style.transition = "0.5s";
      }else{
        this.$refs.navLinkBox.classList.add('active');
      }
    }
  },
  watch: {
    isNavList(newVal, oldVal) {
      // 在监听你使用update事件来更新word,而在父组件不需要调用该函数
      // this.$emit('update:word', newVal);
      console.log(newVal, oldVal)
    }
  }
}

function fontSize(){
    var deviceWidth=document.documentElement.clientWidth>768?768:document.documentElement.clientWidth;
    document.documentElement.style.fontSize=(deviceWidth/25)+"px";
}
fontSize();
</script>

<style scoped>
/* 开始过渡阶段,动画出去阶段 */
body{
  /*height: calc(100% - 3.2rem);*/
  height: 100%;
}
.AppBox{
  height: 100%;
}
#headNavBox {
  width: 100%;
  height: 3.2222rem;
/*  box-shadow: 0 0 10px rgba(190,190,190,0.25);*/
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  z-index: 99;
}
.swiper-container{
  width: 100%;
  height: 100%;
}
.iSlide{
  height: 100%;
}
.iSlide img{
  height: 100%;
}
.headLogo{
  width: 8.4333rem;
  height: 1.6rem;
  display: inline-block;
  margin: 0.8111rem 0 0 1rem;
}
.headNav{
  position: absolute;
  right: 1rem;
  top: 1.2rem;
  width: 1rem;
}
#navLinkBox{
  position: fixed;
  top: -22rem;
  left: 0;
  width: 100%;
  background: rgba(255,255,255,0.95);
  z-index: 90;
}
#navLinkBox.active{
  top: 3.2rem;
  transition: 0.5s;
}
.headNavList{
  width: 100%;
  display: inline-block;
  text-align: center;
  color: #333;
  height: 3.2rem;
  line-height: 3.2rem;
  font-size: 1rem;
  background: rgba(255,255,255,0.95);
  border-bottom: 1px solid #f7f8f9;
}
.homeBox{
  width: 100%;
  height: 100%;
  /*margin: 3.2rem auto 0;*/
  position: absolute;
  top: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue